var map = {
	"./BeatSwapLightLogo.png": 469,
	"./BeatSwapLogo.png": 470,
	"./UdonSwapLogo.png": 142,
	"./arrow-down-blue.svg": 471,
	"./arrow-down-grey.svg": 472,
	"./arrow-right-white.png": 473,
	"./arrow-right.svg": 474,
	"./blue-loader.svg": 203,
	"./circle-grey.svg": 475,
	"./circle.svg": 476,
	"./close.svg": 204,
	"./coinbaseWalletIcon.svg": 144,
	"./discord.png": 205,
	"./dropdown-blue.svg": 477,
	"./dropdown.svg": 478,
	"./dropup-blue.svg": 479,
	"./ethereum-logo.png": 206,
	"./fortmaticIcon.png": 480,
	"./iconstar.png": 481,
	"./link.svg": 482,
	"./magnifying-glass.svg": 483,
	"./maleuser.png": 484,
	"./maleuser2.png": 485,
	"./menu.svg": 207,
	"./metamask.png": 208,
	"./plus-blue.svg": 486,
	"./plus-grey.svg": 487,
	"./portisIcon.png": 488,
	"./question-mark.svg": 489,
	"./question.svg": 490,
	"./search.png": 491,
	"./spinner.svg": 492,
	"./token-list/lists-dark.png": 493,
	"./token-list/lists-light.png": 494,
	"./trustWallet.png": 495,
	"./walletConnectIcon.svg": 145,
	"./web.png": 209,
	"./x.png": 210,
	"./x.svg": 496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 184;